import { render, staticRenderFns } from "./abnormal-page.vue?vue&type=template&id=fc2bdc64&scoped=true&lang=pug&"
import script from "./abnormal-page.vue?vue&type=script&lang=js&"
export * from "./abnormal-page.vue?vue&type=script&lang=js&"
import style0 from "./abnormal-page.vue?vue&type=style&index=0&id=fc2bdc64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2bdc64",
  null
  
)

export default component.exports